import React from 'react';

const AppStoreBadge = ({ onClick, style = {} }) => {
  return (
    <div
      onClick={onClick}
      className="app-store-badge"
      style={{
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        ...style
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'scale(1.05)';
        e.currentTarget.style.filter = 'brightness(1.1)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.filter = 'brightness(1)';
      }}
    >
      <svg width="220" height="65" viewBox="0 0 220 65" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="appStoreGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#1C1C1E" />
            <stop offset="100%" stopColor="#2C2C2E" />
          </linearGradient>
        </defs>
        
        {/* Background with yellow theme */}
        <rect x="1" y="1" width="218" height="63" rx="8" ry="8" fill="#EAB308" stroke="#EAB308" strokeWidth="2"/>
        
        {/* Apple logo with black theme colors */}
        <path d="M34.99671,32.88935a5.14625,5.14625,0,0,1,2.45058-4.31771,5.26776,5.26776,0,0,0-4.15039-2.24376c-1.74624-.1833-3.43913,1.04492-4.329,1.04492-.90707,0-2.27713-1.02672-3.75247-.99637a5.52735,5.52735,0,0,0-4.65137,2.8367c-2.01111,3.482-.511,8.59939,1.41551,11.414.96388,1.37823,2.09037,2.91774,3.56438,2.86315,1.4424-.05983,1.98111-.91977,3.7222-.91977,1.72494,0,2.23035.91977,3.73427.88506,1.54777-.02512,2.52292-1.38435,3.453-2.77563a11.39931,11.39931,0,0,0,1.579-3.21589A4.97284,4.97284,0,0,1,34.99671,32.88935Z" fill="#000000"/>
        <path d="M32.15611,24.47681a5.06687,5.06687,0,0,0,1.159-3.62989,5.15524,5.15524,0,0,0-3.33555,1.72582,4.82131,4.82131,0,0,0-1.18934,3.4955A4.26259,4.26259,0,0,0,32.15611,24.47681Z" fill="#000000"/>
        
        {/* Text with black theme colors - centered */}
        <text x="130" y="25" fill="#000000" fontSize="12" fontFamily="-apple-system, BlinkMacSystemFont, sans-serif" fontWeight="400" textAnchor="middle">Download on the</text>
        <text x="130" y="45" fill="#000000" fontSize="20" fontFamily="-apple-system, BlinkMacSystemFont, sans-serif" fontWeight="700" textAnchor="middle">App Store</text>
      </svg>
    </div>
  );
};

export default AppStoreBadge;